import React, { Component } from 'react';
import { Amount, YesNo } from '../shared';
import CostPrice from './CostPrice';

class HistoryDetails extends Component {
  render() {
    const { item, contact } = this.props;

    return (
      <div>
        <div className="form-group">
          <label>Aantal pakken:</label>
          <span className="form-control auto-height">
            {item.vpackQty}
          </span>
        </div>
        <div className="form-group">
          <label>Totaal aantal pakken:</label>
          <span className="form-control auto-height">
            {item.hstAhPackQty}
          </span>
        </div>
        <div className="form-group">
          <label>Pakinhoud:</label>
          <span className="form-control auto-height">
            {item.packCont}
          </span>
        </div>
        <div className="form-group">
          <label>Zagen:</label>
          <span className="form-control auto-height">
            <YesNo value={item.k1Saw} />
          </span>
        </div>
        <div className="form-group">
          <label>Marge netto verkoop %:</label>
          <span className="form-control auto-height">
            {item.k1Marge}
          </span>
        </div>
        <CostPrice item={item} contact={contact} />
        <div className="form-group">
          <label>Directe levering:</label>
          <span className="form-control auto-height">
            <YesNo value={item.hstAhPoDlb || item.directPx} />
          </span>
        </div>
        <div className="form-group">
          <label>Leverancier code:</label>
          <span className="form-control auto-height">
            {item.vsrcCode}
          </span>
        </div>
        <div className="form-group">
          <label>Betalingsconditie:</label>
          <span className="form-control auto-height">
            {item.hstAhVdiscDesc}
          </span>
        </div>
        <div className="form-group">
          <label>Vervoerskosten:</label>
          <span className="form-control auto-height">
            <Amount amount={item.hstAhShipCost} />
          </span>
        </div>
        <div className="form-group">
          <label>Orderkosten:</label>
          <span className="form-control auto-height">
            <Amount amount={item.hstAhOrdCost} />
          </span>
        </div>
        <div className="form-group">
          <label>Omschrijving order:</label>
          <span className="form-control auto-height">
            {item.hstAhComment1}
          </span>
        </div>
        <div className="form-group">
          <label>Afleverdebiteur:</label>
          <span className="form-control auto-height">
            {item.hstAhDelAddr}
          </span>
        </div>
        <div className="form-group">
          <label>Externe notitie:</label>
          <span className="form-control auto-height">
            {item.hstAhComment2}
          </span>
        </div>
      </div>
    );
  }
}

export default HistoryDetails;



// WEBPACK FOOTER //
// ./src/history/HistoryDetails.js